module.exports = __webpack_public_path__ + "static/media/Vedang_Khedekar.347d3278.jpg";